import React from 'react';
import '../TeleCalling.css';
import { Box, Tooltip, IconButton } from '@mui/material';
import {
    Call,
    WifiCalling3 as WifiCallingIcon,
} from '@mui/icons-material';
import { handleValidateCodevalue } from '../../../Utility/constant';

const CallFab = ({
    isConfigured,
    isListening,
    isIncomingRinging,
    isCallInProgress,
    handleFabClick,
    internationalise,
}) => {
    // Derive FAB colour based on call state
    const fabBg = !isConfigured
        ? '#9e9e9e'
        : isIncomingRinging
        ? 'var(--primary-color)'
        : isCallInProgress
        ? '#d32f2f'
        : 'var(--primary-color)';

    const fabHover = !isConfigured
        ? '#757575'
        : isIncomingRinging
        ? 'var(--secondary-color)'
        : isCallInProgress
        ? '#b71c1c'
        : 'var(--secondary-color)';

    const fabTooltip = !isConfigured
        ? handleValidateCodevalue(internationalise, 'TC_NOT_CONFIGURED') || 'Telecalling not configured'
        : isIncomingRinging
        ? handleValidateCodevalue(internationalise, 'INCOMING_CALL')
        : isCallInProgress
        ? handleValidateCodevalue(internationalise, 'INPROGRESS_CALL')
        : handleValidateCodevalue(internationalise, 'OPEN_CALL_PANEL');

    return (
        <Box className="tc-fab-wrapper">
            <Tooltip title={fabTooltip} placement="left">
                <Box className="fab-container" sx={{ position: 'relative' }}>
                    <IconButton
                        onClick={handleFabClick}
                        sx={{
                            width: 64,
                            height: 64,
                            backgroundColor: fabBg,
                            color: '#fff',
                            boxShadow: isConfigured
                                ? '0 6px 20px rgba(21,101,192,0.45)'
                                : '0 6px 20px rgba(0,0,0,0.15)',
                            transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
                            '&:hover': {
                                backgroundColor: fabHover,
                                boxShadow: isConfigured
                                    ? '0 8px 28px rgba(21,101,192,0.55)'
                                    : '0 6px 20px rgba(0,0,0,0.15)',
                            },
                            // Pulsate on incoming call regardless of configuration status
                            ...(isIncomingRinging && {
                                animation: 'fabRingPulse 0.9s ease-in-out infinite',
                            }),
                        }}
                    >
                        {isCallInProgress || isIncomingRinging ? (
                            <WifiCallingIcon sx={{ fontSize: 28 }} />
                        ) : (
                            <Call sx={{ fontSize: 26 }} />
                        )}
                    </IconButton>

                    {/* Online / offline status dot */}
                    {isConfigured && (
                        <Box
                            className={`fab-status-dot ${
                                isListening ? 'fab-status-dot--online' : 'fab-status-dot--offline'
                            }`}
                        />
                    )}
                </Box>
            </Tooltip>
        </Box>
    );
};

export default CallFab;


